import React from 'react'

export default function ActivityPlanValidationComponent({ validationData }) {
  const filteredInvalidPlannedActivities = validationData.plannedActivities?.filter(
    (pActivity) => !pActivity.valid,
  )
  return (
    <>
      {!validationData?.title?.valid && (
        <div className="pb-3 text-danger">
          <strong>{validationData?.title.message}</strong>
        </div>
      )}
      {!validationData?.phases?.valid && (
        <div className="pb-3 text-danger">
          <strong>{validationData?.phases.message}</strong>
        </div>
      )}

      {filteredInvalidPlannedActivities.length > 0 && (
        <>
          <strong className="text-danger">
            There are some errors in day wise planned activities.
          </strong>
        </>
      )}
    </>
  )
}
